export const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;

export const API_ENDPOINTS_URLS = {
    GetCommomDetails: API_GATEWAY_URL + "common/get_common_details",
    AddCommonDetails: API_GATEWAY_URL + "common/add_common_details",
    Login: API_GATEWAY_URL + "users/login",
    Signup: API_GATEWAY_URL + "users/register_user",
    SessionToken: API_GATEWAY_URL + "users/validate_session_token",
    ForgetPassword: API_GATEWAY_URL + "users/forgot_password",
    ResetPassword: API_GATEWAY_URL + "users/reset_password",
    ValidateForgotLink: API_GATEWAY_URL + "users/validate_forgot_link",
    ChargeCreditCard: API_GATEWAY_URL + "stripe/add_card",
    GetCardDetails: API_GATEWAY_URL + "stripe/get_card_details",
    CompleteSubscription: API_GATEWAY_URL + "stripe/charge_card",
    getUserSubscriptionList: API_GATEWAY_URL + "users/get_subscription_list",

    /* Products */
    GetProducts: API_GATEWAY_URL + "products/listAll",
    AddProduct: API_GATEWAY_URL + "products/add",
    DeleteProduct: API_GATEWAY_URL + "products/delete",
    GetProductDetails: API_GATEWAY_URL + "products/get_details",
    EditProduct: API_GATEWAY_URL + "products/edit",

    /*Activities*/
    GetAllActivity: API_GATEWAY_URL + "activity/listAll",
    GetSearchActivity: API_GATEWAY_URL + "activity/search",
    GetProductActivity: API_GATEWAY_URL + "products/activities_list",
    GetProductSearchActivity: API_GATEWAY_URL + "products/search_activities_list",
    GetActivityReport: API_GATEWAY_URL + "activity/report",
    GetActivityDetail: API_GATEWAY_URL + "activity/details",
    DownloadActivity: API_GATEWAY_URL + "activity/download_pdf",
    DownloadReportCsv: API_GATEWAY_URL + "activity/download_report",
    DownloadAllReportCsv: API_GATEWAY_URL + "activity/download_all_activities",
    DownloadSearchCsv: API_GATEWAY_URL + "activity/download_search_activities",
    DownloadProductwiseCsv: API_GATEWAY_URL + "products/download_activities_list",
    DownloadSearchProductCsv: API_GATEWAY_URL + "products/downlod_search_activities_list",
  

    /*Legal*/
    AddLegal: API_GATEWAY_URL + "legal/add",
    UpdateLegal: API_GATEWAY_URL + "legal/update",
    GetLegalDetails: API_GATEWAY_URL + "legal/details",
    GetListAllLegal: API_GATEWAY_URL + "legal/listAll",
    GetListAllDraftVersions: API_GATEWAY_URL + "legal/listAll_draft_versions",
    GetListAllPublishVersions: API_GATEWAY_URL + "legal/listAll_publish_versions",
    GetLastAddDraftVersion: API_GATEWAY_URL + "legal/last_add_draft_version",
    GetPublishVersionDetails: API_GATEWAY_URL + "legal/publish_version_details",
    GetDraftVersionDetails: API_GATEWAY_URL + "legal/draft_version_details",
    ViewLegalDetails: API_GATEWAY_URL + "legal/view_legal_publish_details",
    ListAllPublishLegals: API_GATEWAY_URL + "legal/listAll_publish_legals",

    /*Profile*/
    Profile: API_GATEWAY_URL + "users/profile",
    GetImage: API_GATEWAY_URL + "users/image",
    AddNewCreditCard: API_GATEWAY_URL + 'stripe/add_new_card',
    UpdateDefaultCard: API_GATEWAY_URL + 'stripe/set_default_card',
    GetInvoices: API_GATEWAY_URL + "billing/get_order_history",
    GetCreditCards: API_GATEWAY_URL + "billing/get_card_details",
    GetInvoiceDetails: API_GATEWAY_URL + "billing/get_invoice_details",
   
    /* Admin */
    GetUsersList: API_GATEWAY_URL + "admin/get_users",
    SearchUsers: API_GATEWAY_URL + "admin/search_users",
    SwitchUser: API_GATEWAY_URL + "admin/switch_account",
    GetUserDetail: API_GATEWAY_URL + "admin/get_user_details",
    GetIPLocation: API_GATEWAY_URL + "admin/get_ip_location",
    UpdateUser: API_GATEWAY_URL + "admin/update_users",
    UpdateNextBillDate: API_GATEWAY_URL + "admin/change_next_bill_date",


};